import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, type MessageDescriptor } from 'react-intl';
import type { To } from 'react-router';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { IOsAppFeature } from '@sorare/core/src/components/BuyableFeature';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { glossary } from '@sorare/core/src/lib/glossary';

const Root = styled(Horizontal).attrs({ gap: 1 })`
  width: 100%;
  padding: var(--unit) 0;
`;

type Props = {
  to?: To;
  text: MessageDescriptor;
};
export const IosHeader = ({ to, text }: Props) => {
  const { formatMessage } = useIntlContext();
  const navigate = useNavigate();
  return (
    <IOsAppFeature>
      <Root>
        <IconButton
          size="medium"
          color="transparent"
          to={to ?? undefined}
          onClick={to ? undefined : () => navigate(-1)}
          icon={faChevronLeft}
          aria-label={formatMessage(glossary.back)}
        />
        <HeadlineL>
          <FormattedMessage {...text} />
        </HeadlineL>
      </Root>
    </IOsAppFeature>
  );
};
